import React, { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "antd";
import Sidebar from "../Components/SideBarMenu/SidebarMenu";
import AppHeader from "../Components/AppHeader/AppHeader";
import PrivateRoute from "../Components/PrivateRoute";
import PageNotFound from "../Pages/PageNotFound";
import ManageAdmins from "../Pages/Users/Admins/ManageAdmins";
import ManageStudent from "../Pages/Users/Students/ManageStudent";
import AddStudent from "../Pages/Users/Students/AddStudent";
import Instructors from "../Pages/Users/Instructors/Instructors";
import AddNewAdmin from "../Pages/Users/Admins/AddNewAdmin";
import Applications from "../Pages/Users/Instructors/Applications";
import AddInstructor from "../Pages/Users/Instructors/AddInstructor";
import Payout from "../Pages/Users/Instructors/Payout";
import InstructorSettings from "../Pages/Users/Instructors/InstructorSettings";
import Message from "../Pages/Message";
import InstallAddon from "../Pages/InstallAddon";
import EditCourse from "../Pages/editCourse/EditCourse.js";
import MyProfile from "../Pages/myProfile/MyProfile.js";

const NotificationSettings = React.lazy(() =>
  import("../Pages/NotificationSettings.js")
);
const WasabiSettings = React.lazy(() => import("../Pages/WasabiSettings"));
const DripContentSettings = React.lazy(() =>
  import("../Pages/DripContentSettings")
);

const BbbLiveClassSettings = React.lazy(() =>
  import("../Pages/BbbLiveClassSettings.js")
);
const PaymentSettings = React.lazy(() => import("../Pages/PaymentSettings.js"));
const SystemSettings = React.lazy(() => import("../Pages/SystemSettings"));
const WebsiteSettings = React.lazy(() => import("../Pages/WebsiteSettings"));
const SocialLogin = React.lazy(() => import("../Pages/SocialLogin"));
const SubscribedUser = React.lazy(() =>
  import("../Pages/newsletter/SubscribedUser")
);
const AllNewsLetter = React.lazy(() =>
  import("../Pages/newsletter/AllNewsLetter")
);

const AddCustomPage = React.lazy(() => import("../Pages/AddCustomPage"));

const ZoomSettings = React.lazy(() => import("../Pages/ZoomSettings"));
const CustomPage = React.lazy(() => import("../Pages/CustomPage"));
const Addonheader = React.lazy(() => import("../Components/Addonheader"));
const Dashboard = lazy(() => import("../Pages/Dashboard"));
// const MyProfile = React.lazy(() => import("../Pages/myProfile/MyProfile.js"))

const DirectorDashboard = React.lazy(() =>
  import("../Pages/directorDashboard/DirectorDashboard")
);

const SkillDevelopment = React.lazy(() =>
  import("../Pages/skillDevelopment/SkillDevelopment")
);

const EmployeeExchange = React.lazy(() =>
  import("../Pages/employeeExchange/EmployeeExchange")
);

const Course = React.lazy(() => import("../Pages/Courses"));
const AddNewCourse = React.lazy(() => import("../Pages/addCourses"));
const Categories = React.lazy(() => import("../Pages/Categories"));
const Coupons = React.lazy(() => import("../Pages/Coupons"));
const AddNewCategory = React.lazy(() => import("../Pages/AddNewCategory"));
const AddNewCoupon = React.lazy(() =>
  import("../Pages/newCoupon/AddNewCoupon")
);
const Contact = React.lazy(() => import("../Pages/Contact"));
const AddNewContact = React.lazy(() => import("../Pages/AddContact"));

const AddBlog = React.lazy(() => import("../Pages/AddBlog"));
const AllBlogs = React.lazy(() => import("../Pages/AllBlogs"));
const PendingBlogs = React.lazy(() => import("../Pages/PendingBlogs"));
const BlogsCategories = React.lazy(() => import("../Pages/BlogsCategories"));
const BlogsSettings = React.lazy(() => import("../Pages/BlogsSettings"));

const CourseEnrollment = React.lazy(() => import("../Pages/CourseEnrollment"));

const EnrollHistory = React.lazy(() => import("../Pages/Enroll_history"));

const { Content } = Layout;

const AuthenticatedRoutes = () => {
  const location = useLocation();
  const isDashboard = location.pathname === "/";
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ display: "flex" }}>
        {location.pathname !== "/" && <Sidebar collapsed={collapsed} />}
        <Layout style={{ flex: 1 }}>
          <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} />
          <Content
            style={{
              padding: "0 50px",
              marginTop: 0,
              minHeight: 280,
            }}
          >
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                {isDashboard ? (
                  <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                ) : (
                  <>
                    {/* Director Dashboard */}
                    <Route
                      path="/director-dashboard"
                      element={
                        <PrivateRoute>
                          <DirectorDashboard />
                        </PrivateRoute>
                      }
                    />

                    {/* EmployeeExchange */}
                    <Route
                      path="/employee-exchange"
                      element={
                        <PrivateRoute>
                          <EmployeeExchange />
                        </PrivateRoute>
                      }
                    />
                    {/* SkillDevelopment */}
                    <Route
                      path="/skill-development"
                      element={
                        <PrivateRoute>
                          <SkillDevelopment />
                        </PrivateRoute>
                      }
                    />

                    {/* Courses */}
                    <Route
                      path="/courses/manage-course"
                      element={
                        <PrivateRoute>
                          <Course />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/add-new-course"
                      element={
                        <PrivateRoute>
                          <AddNewCourse />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/edit-course/:id"
                      element={
                        <PrivateRoute>
                          <EditCourse />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/course-categories"
                      element={
                        <PrivateRoute>
                          <Categories />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/category/add_category"
                      element={
                        <PrivateRoute>
                          <AddNewCategory />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/category/edit_category/:id"
                      element={
                        <PrivateRoute>
                          <AddNewCategory />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/coupons"
                      element={
                        <PrivateRoute>
                          <Coupons />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/coupons/add"
                      element={
                        <PrivateRoute>
                          <AddNewCoupon />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/contacts/contact/add"
                      element={
                        <PrivateRoute>
                          <AddNewContact />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/contacts/contact/edit/:id"
                      element={
                        <PrivateRoute>
                          <AddNewContact />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/courses/coupons/edit/:id"
                      element={
                        <PrivateRoute>
                          <AddNewCoupon />
                        </PrivateRoute>
                      }
                    />

                    {/* Enrollments */}
                    <Route
                      path="/enrollments/course"
                      element={<CourseEnrollment />}
                    />
                    <Route
                      path="/enrollments/enroll-history"
                      element={<EnrollHistory />}
                    />

                    {/* Contact */}
                    <Route
                      path="/contact"
                      element={
                        <PrivateRoute>
                          <Contact />
                        </PrivateRoute>
                      }
                    />

                    {/* Blogs */}
                    <Route
                      path="/blogs/all-blogs"
                      element={
                        <PrivateRoute>
                          <AllBlogs />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blogs/pending-blogs"
                      element={
                        <PrivateRoute>
                          <PendingBlogs />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blog/category"
                      element={
                        <PrivateRoute>
                          <BlogsCategories />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blog/settings"
                      element={
                        <PrivateRoute>
                          <BlogsSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blogs/add"
                      element={
                        <PrivateRoute>
                          <AddBlog />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/blogs/edit/:id"
                      element={
                        <PrivateRoute>
                          <AddBlog />
                        </PrivateRoute>
                      }
                    />

                    {/* Users */}
                    <Route
                      path="/users/admin-users"
                      element={
                        <PrivateRoute>
                          <ManageAdmins />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-users/add"
                      element={
                        <PrivateRoute>
                          <AddNewAdmin />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-users/edit/:id"
                      element={
                        <PrivateRoute>
                          <AddNewAdmin />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-instructors"
                      element={
                        <PrivateRoute>
                          <Instructors />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-instructors/add"
                      element={
                        <PrivateRoute>
                          <AddInstructor />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-instructors/edit/:id"
                      element={
                        <PrivateRoute>
                          <AddInstructor />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-instructors/payouts"
                      element={
                        <PrivateRoute>
                          <Payout />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-instructors/settings"
                      element={
                        <PrivateRoute>
                          <InstructorSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-instructor-applications"
                      element={
                        <PrivateRoute>
                          <Applications />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-students"
                      element={
                        <PrivateRoute>
                          <ManageStudent />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-students/add"
                      element={
                        <PrivateRoute>
                          <AddStudent />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/users/admin-students/edit/:id"
                      element={
                        <PrivateRoute>
                          <AddStudent />
                        </PrivateRoute>
                      }
                    />

                    <Route
                      path="/my-profile"
                      element={
                        <PrivateRoute>
                          <MyProfile/>
                        </PrivateRoute>
                      }
                    />

                    {/* Message */}
                    <Route
                      path="/messages"
                      element={
                        <PrivateRoute>
                          <Message />
                        </PrivateRoute>
                      }
                    />

                    {/* newsletter routes */}
                    <Route
                      path="newsletter/all-newsletters"
                      element={
                        <PrivateRoute>
                          <AllNewsLetter />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="newsletter/subscribed-users"
                      element={
                        <PrivateRoute>
                          <SubscribedUser />
                        </PrivateRoute>
                      }
                    />

                    {/* Addons */}
                    <Route
                      path="/addons/all-addons"
                      element={
                        <PrivateRoute>
                          <Addonheader />
                        </PrivateRoute>
                      }
                    />

                    {/* settings section routes */}
                    <Route
                      path="/settings/system-settings"
                      element={
                        <PrivateRoute>
                          <SystemSettings />
                        </PrivateRoute>
                      }
                    />
                    {/* <Route
                      path="/settings/website-settings"
                      element={
                        <PrivateRoute>
                          <WebsiteSettings />
                        </PrivateRoute>
                      }
                    /> */}
                    <Route
                      path="/settings/drip-content-settings"
                      element={
                        <PrivateRoute>
                          <DripContentSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/wasabi-storage-settings"
                      element={
                        <PrivateRoute>
                          <WasabiSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/zoom-settings"
                      element={
                        <PrivateRoute>
                          <ZoomSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/custom-page"
                      element={
                        <PrivateRoute>
                          <CustomPage />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/add-custom-page"
                      element={
                        <PrivateRoute>
                          <AddCustomPage />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/add-custom-page/:id"
                      element={
                        <PrivateRoute>
                          <AddCustomPage />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/social-settings"
                      element={
                        <PrivateRoute>
                          <SocialLogin />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/notification-settings"
                      element={
                        <PrivateRoute>
                          <NotificationSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/payment-settings"
                      element={
                        <PrivateRoute>
                          <PaymentSettings />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/settings/bbb-live-class-settings"
                      element={
                        <PrivateRoute>
                          <BbbLiveClassSettings />
                        </PrivateRoute>
                      }
                    />

                    {/* <Route path="*" element={<PageNotFound />} /> */}
                  </>
                )}
              </Routes>
            </Suspense>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default AuthenticatedRoutes;
